import React from "react";
import { Address, DocumentUrl } from "../../models/cartable.model";
import DivisionCmp from "../../components/cards/DivisionCmp";
import DetailInfoComponentThumbnail from "../../components/detailInfo/detailInfoComponentThumbnail";
import { SectionModel } from "../../models/components.model";
import DivisionInstallment from "../../components/cards/DivisionInstallment";


export default function ScheduleInstallment({ data, setDataGetInstallmentTable }: any) {
    return (
        <>
            <DivisionInstallment title={"جدول اقساط"} data={data} />
        </>
    );
}
